export default __webpack_public_path__ + "static/media/10.bf040996.png";